



































import { Component, Watch, Prop, Vue } from 'vue-property-decorator';
import router from '../router';
import * as $ from 'jquery';
import { IframeParentCommnuicationService } from '@/services/IframeParentCommnuicationService';
import {
    GenericModal,
    GenericModalType,
    GenericModalCancelLabel,
    GenericModalContinueLabel,
    GenericModalTitle,
    GenericModalOption,
    GenericModalResponse
} from '../models/GenericModal';

@Component({})
export default class AudienceGenericModal extends Vue {

    private continueLabel: string = '';
    private cancelLabel: string = '';
    private titleLabel: string = '';
    private mesageLabel: string = '';
    private options: GenericModalOption[] = [];
    private id: string = '';
    private requesting: any = null;

    private iframeParentCommnuicationService = new IframeParentCommnuicationService();

    public show(request: GenericModal): void {
        this.id = request.id;
        this.options = request.options;
        this.continueLabel = request.continueLabel();
        this.cancelLabel = request.cancelLabel();
        this.titleLabel = request.titleLabel();
        this.mesageLabel = request.message;
        this.requesting = request.requesting;

        $('#genModal').modal('show');

        const data = { action: 'eIn_modal_dialog', value: '' };
        this.iframeParentCommnuicationService.SendMessageToParent(data);

        // $([document.documentElement, document.body]).animate({
        //     scrollTop: $('#genModal').offset().top
        // }, 1000);
    }

    private hide() {
        $('#genModal').modal('hide');
    }

    private cancel(): void {
        this.$emit('onCancel', this.getResponse());
    }

    private advance(): void {
        this.$emit('onContinue', this.getResponse());
    }

    private getResponse(): GenericModalResponse {
        const res: GenericModalResponse = {
            id: this.id,
            options: this.options,
            requested: this.requesting
        };
        return res;
    }
}
